import axios, { AxiosResponse } from "axios"
import { ShopPage } from "./ShopPage"

function fetchShop() {
	return axios.get<any, AxiosResponse<ShopPage>>("/getShop")
}

export default fetchShop
